// extracted by mini-css-extract-plugin
export default {"margin":"SchoolAuthenticationCodeGenerator_margin__neCEq","Searchinput":"SchoolAuthenticationCodeGenerator_Searchinput__WUs6-"};